import { ApiRoutes } from '../constant/api';
import { api } from '../helpers/axios';
import { PersonsResponseType } from '../types/person.types';

export const personApi = {
	getPersonById: (personId: number) => api.get(`${ApiRoutes.Persons}/${personId}`),
	getPersons: (offset?: number, limit?: number) =>
		api
			.get(`${ApiRoutes.Persons}`, {
				params: {},
			})
			.then((res) => (res.data as PersonsResponseType)?.objects),
};
